export const addFeatureToPlan = () => {
  const featuresContainer = document.getElementById('plan-features');
  const addButton = document.getElementById('add-feature');
  const template = document.getElementById('plan-feature-template');

  if (!featuresContainer || !addButton || !template) return;

  addButton.addEventListener('click', () => {
    const index = Date.now(); // cheap unique id
    const html = template.innerHTML.replace(/NEW_RECORD/g, index);
    featuresContainer.insertAdjacentHTML('beforeend', html);
  });

  // Delegate remove button clicks
  featuresContainer.addEventListener('click', (event) => {
    if (event.target.matches('[data-remove-feature]')) {
      const row = event.target.closest('[data-feature-row]');
      if (!row) return;

      // If this row has a hidden _destroy field (persisted record),
      // set it to "1" and hide, instead of removing the inputs.
      const destroyInput = row.querySelector("input[name*='[_destroy]']");
      if (destroyInput) {
        destroyInput.value = '1';
        row.style.display = 'none';
      } else {
        // For new records, just remove the row from DOM
        row.remove();
      }
    }
  });
};
